module.exports = __webpack_public_path__ + "static/media/step3.f984a4d5.jpeg";